import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {firstValueFrom, map} from "rxjs";
import {Form} from "@shared/api/models/query/form.model";
import {FormQuestionList} from "@ctms/api/api.interfaces";
import {environment} from "../../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class FormsService extends PaginatorService<Form> {

    protected override get domainEntity() {
        return 'lists/forms';
    };

    async listQuestions(formId: number): Promise<FormQuestionList> {
        const url = `${environment.baseApiUrl}v2/forms/${formId}/questions`;
        let result = this.http.get<any>(url)
            .pipe(
                map((response) => {
                    return response;
                })
            )
        return firstValueFrom(result)
    }
}
